import { BenchmarkGranularity } from "app/pages/benchmark-tracker/services/api/constants";
import type { MetaDataEntity } from "app/pages/benchmark-tracker/types/api.types";
import type { IFetchService } from "app/services/fetchService";

import { BENCHMARK_USER_API, BENCHMARKS_ENDPOINT } from "./constants";

type ReportApiServiceEntity = {
    fetchGAMetaData(benchmarkId: string): Promise<MetaDataEntity>;
    subscribeToDigest(benchmarkId: string, granularity?: BenchmarkGranularity): Promise<void>;
    unsubscribeFromDigest(benchmarkId: string): Promise<void>;
};

export const reportApiService = (fetchService: IFetchService): ReportApiServiceEntity => {
    return {
        fetchGAMetaData: async (benchmarkId: string): Promise<MetaDataEntity> => {
            return await fetchService.get(`${BENCHMARKS_ENDPOINT}/metadata`, {
                id: benchmarkId,
            });
        },
        subscribeToDigest: async (
            benchmarkId: string,
            granularity: BenchmarkGranularity = BenchmarkGranularity.MONTHLY,
        ): Promise<void> => {
            return fetchService.put(
                `${BENCHMARK_USER_API}/subscribe?benchmarkId=${benchmarkId}&granularity=${granularity}`,
            );
        },
        unsubscribeFromDigest: async (benchmarkId: string): Promise<void> => {
            return fetchService.delete(`${BENCHMARK_USER_API}/unsubscribe?benchmarkId=${benchmarkId}`);
        },
    };
};
